
import React from 'react';
import ScrollReveal from './ScrollReveal';
import PricingCard from './PricingCard';

interface PricingSectionProps {
  title?: string;
  description?: string;
  pricingCards: any[];
}

const PricingSection: React.FC<PricingSectionProps> = ({ 
  title = "Pricing Plans", 
  description = "Choose the plan that works best for your needs.", 
  pricingCards 
}) => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {title && (
          <ScrollReveal>
            <h2 className="text-3xl md:text-4xl font-display font-medium text-center mb-4">
              {title}
            </h2>
          </ScrollReveal>
        )}
        
        {description && (
          <ScrollReveal delay={100}>
            <p className="text-lg text-astrem-gray-600 text-center max-w-2xl mx-auto mb-12">
              {description}
            </p>
          </ScrollReveal>
        )}
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {pricingCards.map((card, index) => (
            <ScrollReveal key={index} delay={200 + (index * 100)}>
              <PricingCard {...card} />
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
